<template>
  <div class="content hp_space_between">
    <div class="left">
      <router-view />
    </div>
    <advertising></advertising>
  </div>
</template>
<script>
import advertising from "@/components/Advertising";
export default {
  components: {
    advertising,
  },
  data() {
    return {};
  },
};
</script>
<style lang="less" scoped>
.content {
  width: 1200px;
  margin: 0 auto;
}
</style>
